import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { FUNCIONALIDADES, PAGINAS, ROUTES } from '../../../routes';
import { AtendimentoPadraoForm } from '../components/AtendimentoPadraoForm';
import * as service from './atendimentos_reintegracao.service';
export var AtendimentosReintegracaoEditar = function () {
    return (_jsx(AtendimentoPadraoForm, { pagina: PAGINAS.ATENDIMENTOS_REINTEGRACAO, pagina_chave: FUNCIONALIDADES.ATENDIMENTOS_REINTEGRACAO, rota: ROUTES.ATENDIMENTOS_REINTEGRACAO, services: service }));
};
export default AtendimentosReintegracaoEditar;
